import { render, staticRenderFns } from "./profileBuSbujk.vue?vue&type=template&id=544e1688&scoped=true&"
import script from "./profileBuSbujk.vue?vue&type=script&lang=js&"
export * from "./profileBuSbujk.vue?vue&type=script&lang=js&"
import style0 from "./profileBuSbujk.vue?vue&type=style&index=0&id=544e1688&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544e1688",
  null
  
)

export default component.exports